import ProductionPlants from './ProductionPlants';

export default ProductionPlants;
